import React from "react";
import "./button.scss";

const Button = (props) => {
  return (
    <div className="btn">
      <button
        className={`button ${props.className}`}
        disabled={props.disabled}
        onClick={props.onClick}
      >
        {props.title}
      </button>
    </div>
  );
};

export default Button;
